import { get } from 'lodash'

export default function (fields = {}) {
  return {
    content: get(fields, 'content'),
    severity: get(fields, 'severity'),
    isVisible: get(fields, 'isVisible')
  }
}
